import React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';
import { Button } from '../../components';
import { BaseModal, ChevronRightIcon } from '../../ui';
import Theme from '../../theme';

interface IProps {
  referredByFullname: string,
  referredByUserId: string,
  isVisible: boolean,
  workoutInviteId?: string;
  closeModal(): void;
  t(key: string, options?: any): string;
}

export const InviteModal = ({
  t, referredByFullname, referredByUserId, isVisible, closeModal, workoutInviteId }: IProps) => (
  <BaseModal
    title={''}
    useFullWidth
    closeIconSize={35}
    modalContainer={{ backgroundColor: Theme.WHITE }}
    isModalVisible={isVisible}
    closeModal={closeModal}>
    <View style={styles.container}>
      <Image source={require('../../assets/images/logo-centered-slogan.png')} style={styles.logo} />
      <Text style={styles.waitingHeader}>{t('isWaitingForYou', {
        name: decodeURI(referredByFullname).replace('+', ' '),
      }).toUpperCase()}</Text>
      <Text style={styles.setUpheader}>{t('letsSetYouUp').toUpperCase()}</Text>

      <InviteStep step={1} description={t('inviteStep1')} />
      <InviteStep step={2} description={t('inviteStep2')} />
      <InviteStep step={3} description={t('inviteStep3', {
        name: decodeURI(referredByFullname).replace('+', ' '),
        context: workoutInviteId ? 'booking' : 'no_booking',
      })} />

      <View style={styles.footer}>
        <Button
          title={t('continue')}
          fontColor={Theme.WHITE}
          onPress={closeModal}
        />
      </View>
    </View>
  </BaseModal>
);

interface IInviteStepProps {
  step: number;
  description: string;
}

const InviteStep = ({ step, description }: IInviteStepProps) => (
  <View style={styles.stepContainer}>
    <ChevronRightIcon width={18} height={18} color={Theme.PRIMARY} />
    <View style={styles.stepTextContainer}>
      <Text>
        <Text style={styles.step}>Step {step}: </Text>
        <Text style={styles.description}>{description}</Text>
      </Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignContent: 'center',
  },
  logo: {
    width: 280,
    height: 150,
    resizeMode: 'contain',
    paddingBottom: 20,
    alignSelf: 'center',
  },
  waitingHeader: {
    fontSize: 20,
    paddingTop: 30,
    color: Theme.CHARCOAL,
    textAlign: 'center',
    fontFamily: Theme.Custom700,
  },
  setUpheader: {
    fontSize: 30,
    paddingBottom: 30,
    color: Theme.CHARCOAL,
    textAlign: 'center',
    fontFamily: Theme.Custom700,
  },
  stepContainer: {
    paddingBottom: 20,
    flexDirection: 'row',
    paddingHorizontal: 10,
  },
  stepTextContainer: {
    flexWrap: 'wrap',
    paddingHorizontal: 10,
    flexDirection: 'row',
  },
  step: {
    fontSize: 20,
    lineHeight: 20,
    paddingRight: 10,
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom700,
  },
  description: {
    fontSize: 20,
    lineHeight: 20,
    color: Theme.CHARCOAL,
    fontFamily: Theme.Custom500,
  },
  footer: {
    flex: 1,
    paddingVertical: 10,
    alignContent: 'flex-end',
    justifyContent: 'flex-end',
  },
});
